module.exports = __webpack_public_path__ + "img/shipilin.2b71a79a.png";